import Actions                  from 'Redux/Actions';
import { UserTicketRepository } from 'Domain/Repositories';
import { ofType }               from 'redux-observable';
import { from, EMPTY }          from 'rxjs';
import { mergeMap }             from 'rxjs/operators';
import { TEpic }                from 'Redux/Config';

export const findUserTicketEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findUserTicketRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        UserTicketRepository.findById(id)
          .then((userTicket) => Actions.findUserTicketSuccess({ userTicket }))
          .catch(error => Actions.findUserTicketFailure({ error })),
      );
    }),
  );
};
